import { render } from "./QuadstarPlansView.vue?vue&type=template&id=64a1eb48&scoped=true"
import script from "./QuadstarPlansView.vue?vue&type=script&lang=js"
export * from "./QuadstarPlansView.vue?vue&type=script&lang=js"

import "./QuadstarPlansView.vue?vue&type=style&index=0&id=64a1eb48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64a1eb48"]])

export default __exports__